/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from '@chakra-ui/react'
import { debounce } from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'
import ParticipantsList from './participants'
import Teams from './teams'
import {
	useLoadActivityParticipant,
	useSearchOrgContacts,
} from './../../../hooks/activity.hooks'

const ParticipantTabView = ({
	activity,
	activityTypeDetails,
	isOpen,
	onClose,
	showExternal = true,
	addExternalUsers = null,
	inviteDelegate = false,
	addDelegate = null,
	activeTab,
}) => {
	const [searchQuery, setsearchQuery] = useState('')
	const [activeParticipants, setActiveParticipants] = useState([])
	const [participantPayload, setParticipantPayload] = useState({})

	const { mutate: mutateActivityParticipant, data: participantData } =
		useLoadActivityParticipant()
	const { mutate: searchContactMutate } = useSearchOrgContacts()
	const [data, setdata] = useState([])

	const onDebounceSearch = useCallback(
		debounce(e => {
			setsearchQuery(e.target.value)
		}, 400)
	)
	const loadContacts = useCallback(searchQuery => {
		searchContactMutate(
			{ searchQuery },
			{
				onSuccess: async data => {
					setdata(data)
				},
			}
		)
	})

	useEffect(() => {
		loadContacts()
		loadActivityParticipant()
	}, [])

	const loadActivityParticipant = () => {
		mutateActivityParticipant(
			{ activity_id: activity.activity_id },
			{
				onSuccess: async data => {
					let activeOwners = data
						? (data.list || []).filter(u => !!u.asset_flag_is_owner)
						: []
					let activeExternals = data
						? (data.list || []).filter(u => u.asset_type_category_id === 45)
						: []
					let activeInternals = data
						? (data.list || []).filter(u => u.asset_type_category_id) //Should fetch all participants
						: []
					let viewers = data
						? (data.list || []).filter(
								u => u.asset_participant_access_id === 152
						  )
						: []
					setParticipantPayload({
						activeOwners,
						activeExternals,
						activeInternals,
						viewers,
					})
					let activepId = data ? (data.list || []).map(u => u.asset_id) : []
					setActiveParticipants(activepId)
				},
			}
		)
	}

	const onReload = () => {
		loadActivityParticipant()
		setsearchQuery('')
	}

	return (
		<>
			<Box display='flex' p='10px' h='100%' w='100%' bg='#F5F5F5'>
				{activeTab.current === 'Participants' ? (
					<ParticipantsList
						onSetReload={onReload}
						participantPayload={participantPayload}
						activity={activity}
						activityTypeDetails={activityTypeDetails}
						search_string={searchQuery}
						setActiveParticipants={setActiveParticipants}
						participantData={participantData}
					/>
				) : (
					<Teams
						activity={activity}
						search_string={searchQuery}
						activeParticipants={activeParticipants}
						onSetReload={onReload}
						inviteDelegate={inviteDelegate}
						addDelegate={addDelegate}
						data={data}
						setdata={setdata}
					/>
				)}
			</Box>
		</>
	)
}

export default ParticipantTabView
